import { DateTime, Duration } from 'luxon';
import { fromJsonArray } from 'src/core/utils';
import VideoRating from 'src/entities/video/VideoRating';
import VideoResource from 'src/entities/video/VideoResource';

export default class Video {
    id: string;
    localizedName: string;
    normalizedName: string;
    coverImageUrl: string;
    length: Duration;
    notVisibleLocalizedReason: string;
    rating?: number;
    ratings: VideoRating[];
    resources: VideoResource[];
    ratedOn?: DateTime;

    constructor(json: any) {
        this.id = json.id;
        this.localizedName = json.localizedName;
        this.normalizedName = json.normalizedName;
        this.coverImageUrl = json.coverImageUrl;
        this.length = Duration.fromObject({ seconds: json.length });
        this.notVisibleLocalizedReason = json.notVisibleLocalizedReason;
        this.rating = json.rating;
        this.ratings = fromJsonArray(VideoRating, json.ratings);
        this.resources = fromJsonArray(VideoResource, json.resources);
        this.ratedOn = json.ratedOn ? DateTime.fromISO(json.ratedOn) : undefined;
    }

    get notVisible(): boolean {
        return this.notVisibleLocalizedReason !== '';
    }

    get isRated(): boolean {
        return this.rating !== undefined && this.rating !== null;
    }

    get hasResources(): boolean {
        return this.resources.some(r => r.isAvailable);
    }

    get isRateable(): boolean {
        return !this.notVisible && this.hasResources;
    }
}
